import React, { useContext } from "react";
// import "../../App.css";
import { AppContext } from "../context/Context";
import { BASE_URL } from "../api/Api";
import { Link } from "react-router-dom";
const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
export default function Navbar() {
  const { siteSetting, loading } = useContext(AppContext);
const user = JSON.parse(localStorage.getItem("user"));

if (loading || !siteSetting) {
  return (
    <div className="logo-bar text-center py-3">
      Loading...
    </div>
  );
}

  return (
    <>
    
      {/* ===== LOGO BAR ===== */}
      <div className="logo-bar d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <Link to="/" className="d-flex align-items-center" style={{ textDecoration: "none", color: "inherit" }}>
          <img
            src={`${BASE_URL}/assets/images/${siteSetting.logo3}`}
            alt="Emblem"
            className="emblem"
          />
          </Link>
          <div className="ms-3">
            <div className="logo-title">
              {siteSetting.site_name_marathi}
            </div>
            <div className="logo-title">
              {siteSetting.site_name_english}
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <img
            src={`${BASE_URL}/assets/images/${siteSetting.logo2}`}
            alt=""
            className="right-logo"
          />
          <img
            src={`${BASE_URL}/assets/images/${siteSetting.logo1}`}
            alt=""
            className="right-logo ms-3"
          />
        </div>
      </div>

      {/* ===== MAIN NAVBAR ===== */}
      <nav className="navbar navbar-expand-lg main-navbar">
        <div className="container-fluid">
          <div className="d-flex align-items-center">
            <div className="nav-csr-box">
             <Link to="/" className="nav-csr-link" style={{ textDecoration: "none", color: "inherit" }}>
              CSR
              </Link>
            </div>
            <div className="ms-2">
              <div className="nav-csr-title">CSR Portal</div>
              <div className="nav-csr-subtitle">
                Corporate Social Responsibility
              </div>
            </div>
          </div>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="mainNav">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/projects">Projects</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/gallery">Gallery</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/guidelines">Guidelines</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/contact_us">Contact Us</Link></li>
            </ul>

          <div className="d-flex align-items-center gap-3">

  {!user ? (
    <Link to="/registration" className="btn login-btn">
      <i className="bi bi-person"></i> Registration
    </Link>
  ) : (
    <div className="dropdown">
      <button
        className="btn login-btn dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
      >
        <i className="bi bi-person-circle me-1"></i>
        {user.name}
      </button>

      <ul className="dropdown-menu dropdown-menu-end">
        <li>
        <button
  className="dropdown-item"
  onClick={() => {

    window.location.href = `${LOGIN_URL}`;

    window.location.href = `${ADMIN_URL}`;

  }}
>
  Dashboard
</button>
        </li>
        <li>
        <button
  className="dropdown-item text-danger"
  onClick={() => {
    localStorage.clear();
    window.location.href = "/registration";
  }}
>
  Logout
</button>

        </li>
      </ul>
    </div>
  )}

</div>

          </div>
        </div>
      </nav>
    </>
  );
}
